import { 
  Store as StoreIcon,
  LaunchOutlined as LaunchIcon 
} from '@mui/icons-material';

interface CardIdentifierProps {
  index: number;
  shippingNumber: string | number;
  commerceShippingNumber: string | null | undefined;
  commerceName: string | undefined;
  onOpenDetails: () => void;
}

const CardIdentifier = ({
  index,
  shippingNumber,
  commerceName,
  onOpenDetails,
}: CardIdentifierProps) => {
  const openOldSystemHistory = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`https://soydelivery.com.uy/viewpedido.aspx?${shippingNumber}#General`,'_blank');
  };

  return (
    <div className='flex items-center gap-4 flex-1'>
      <div className='w-12 h-12 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center font-black text-base'>
        {index}
      </div>
      <div className='flex flex-col'>
        <div className='flex items-center gap-3'>
          <span 
            onClick={onOpenDetails}
            className='font-black text-[#2196f3] hover:text-[#1976d2] text-xl leading-tight cursor-pointer transition-colors flex items-center gap-1.5'
            title='Ver detalle del envío'
          >
            <LaunchIcon sx={{ fontSize: 18 }} />
            {shippingNumber}
          </span>
          <div className='flex gap-1.5'>
            <span
              onClick={openOldSystemHistory}
              className='text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded font-black uppercase cursor-pointer hover:bg-gray-200 transition-colors flex items-center gap-1'
              title='Ver historial (sistema viejo)'
            >
              <LaunchIcon sx={{ fontSize: 11 }} />
              {shippingNumber}
            </span>
          </div>
        </div>
        <div className='flex items-center gap-1.5 text-sm text-gray-400 font-bold mt-0.5'>
          <StoreIcon sx={{ fontSize: 16 }} />
          {commerceName || 'Cargando...'}
        </div>
      </div>
    </div>
  );
};

export default CardIdentifier;
